// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__e04iz","location":"Header_location__27KvX"};